import { combineReducers } from 'redux';
import { operatorUserReducer } from './OperatorUserReducer';

export default combineReducers({
  operatorUser: operatorUserReducer,
});
